module.exports = __webpack_public_path__ + "static/media/eggplant.d2ac8dad.png";